import type { IconProps } from "./icon-types";

/**
 * ArrowUpRight 공용 UI glyph.
 *
 * Lucide의 `LuArrowUpRight` geometry를 정적 SVG로 인라인 — c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const ArrowUpRightIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M7 7h10v10" />
    <path d="M7 17 17 7" />
  </svg>
);
